import React from 'react';

// Shared by the file table and the search results so both show the same
// type label and icon for a given file.

export type FileKind = 'dir' | 'video' | 'audio' | 'pdf' | 'doc' | 'generic';

const videoExts = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm', 'mpeg', 'mpg', '3gp', 'rmvb', 'rm', 'ts', 'm4v'];
const audioExts = ['mp3', 'wav', 'aac', 'flac', 'ogg', 'm4a', 'wma', 'amr', 'aiff', 'ape'];
const docExts = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'md', 'csv', 'rtf', 'odt', 'ods', 'odp'];

export function fileKind(name: string, isDir: boolean): FileKind {
  if (isDir) return 'dir';
  const ext = name.includes('.') ? (name.split('.').pop() as string).toLowerCase() : '';
  if (videoExts.includes(ext)) return 'video';
  if (audioExts.includes(ext)) return 'audio';
  if (ext === 'pdf') return 'pdf';
  if (docExts.includes(ext)) return 'doc';
  return 'generic';
}

const kindLabels: Record<FileKind, string> = {
  dir: '目錄',
  video: '視頻',
  audio: '音頻',
  pdf: '文件',
  doc: '文件',
  generic: '文件'
};

export function kindLabel(kind: FileKind): string {
  return kindLabels[kind];
}

const iconShapes: Record<FileKind, React.ReactNode> = {
  dir: <><path d="M3 7h6l2 2h10v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" /><path d="M3 7V5a2 2 0 0 1 2-2h4l2 2" /></>,
  video: <><rect x="3" y="4" width="18" height="16" rx="2" /><polygon points="10 9 16 12 10 15" fill="currentColor" stroke="none" /></>,
  audio: <><path d="M9 18V5l10-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="18" cy="16" r="3" /></>,
  pdf: <><path d="M6 2h7l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z" /><path d="M13 2v6h6" /></>,
  doc: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" /><path d="M14 2v6h6" /><path d="M8 13h8" /><path d="M8 17h5" /></>,
  generic: <><path d="M6 2h7l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z" /><path d="M8 13h8" /><path d="M8 17h5" /></>
};

export const FileIcon: React.FC<{ kind: FileKind }> = ({ kind }) => (
  <svg className={`file-icon file-icon--${kind}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {iconShapes[kind]}
  </svg>
);
